import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import PedidoPrevisaoEntrega from "../classes/PedidoPrevisaoEntrega";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "PedidoPrevisaoEntrega/RecuperarPorFiltro" },
  { method: "PUT", rota: "PedidoPrevisaoEntrega/AtualizarLote" }
];

const apiServico: string = "PEDIDOS";

export default class PedidoPrevisaoEntregaDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  async get(idFornecedor: number, pedidoId: number, item: number): Promise<PedidoPrevisaoEntrega[]> {
    let ok: boolean = false;
    let data: PedidoPrevisaoEntrega[];
    let error: any = undefined;
    let url: string = `${calls[0].rota}?IdFornecedor=${idFornecedor}&pedidoId=${pedidoId}&item=${item}`;
    await super
      .Get(url)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        data = PedidoPrevisaoEntrega.fromJson(response.data);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<PedidoPrevisaoEntrega[]>((resolve) => {
      resolve(data);
    });
  }

  async update(values: object, idFornecedor: number): Promise<boolean> {
    let error: any = undefined;
    return super
      .put(`${calls[1].rota}?idFornecedor=${idFornecedor}`, values)
      .then((response: AxiosResponse) => {
        return true;
      })
      .catch((erro) => {
        error = erro;
        console.error(erro);
        if (error !== undefined) throw error;
        return false;
      });
  }
}
